<template>
	<div class="home-flow">
		<Empty v-if="!pageMenus.length" :text="$t('enterprise.no-menu-data')" />
		<ContentPad v-else>
			<div class="menu-wrapper">
				<SmartLayoutC
					compId="home_menu_block"
					mode="basic"
					v-for="menu in pageMenus"
					:key="menu.id"
					:menu="menu"
				>
					<template #module="{ module }">
						<SmartDisplayC
							:key="getModuleKey(module)"
							:compId="getModuleId(module)"
							mode="overview"
							v-bind="getModuleProps(module)"
						></SmartDisplayC>
					</template>
				</SmartLayoutC>
			</div>
		</ContentPad>
	</div>
</template>

<script setup>
import { ref, computed, inject, onMounted } from 'vue';
import SmartLayoutC from '@rebuild/components/SmartLayoutC.vue';
import SmartDisplayC from '@rebuild/components/SmartDisplayC.vue';
import ContentPad from '@rebuild/materials/shared/common/ContentPad.vue';
import { useModuleAttrs } from '@rebuild/hooks/useModuleAttrs';
import { useCoreData } from '@rebuild/hooks/data/useCoreData';
import { refreshIframeDataKey } from '@rebuild/hooks/message';
import { useFlow } from '@rebuild/hooks/useFlow';
import { useStore } from '@/utils/vue-api';
import { useBusEvent } from '@rebuild/hooks/useBusEvent';
import { useCurrentContext } from './context';

const context = useCurrentContext();
const getFormattedMenus = computed(() => context.formattedMenus);

const templateMenus = inject('TEMPLATE_MENUS');
const getTemplateMenus = computed(() => templateMenus?.value || []);

const pageMenus = ref([]);
const setPageMenus = data => {
	const formattedFn = getFormattedMenus.value;
	pageMenus.value = formattedFn(data);
};

onMounted(() => {
	setPageMenus(getTemplateMenus.value);
});

const store = useStore();
const { setTemplateData } = useCoreData();
const { composeFlowMenu } = useFlow();

// 监听模板数据变化 更新视图
useBusEvent('iframe-message', msgData => {
	const { iframePreviewData } = msgData;
	if (typeof iframePreviewData != 'undefined') {
		setTemplateData(refreshIframeDataKey(iframePreviewData));
		const normalMenus = store.getters.getNormalMenus || [];
		setPageMenus(composeFlowMenu(normalMenus));
	}
});

const { getModuleId, getModuleProps, getModuleKey } = useModuleAttrs();
</script>

<style lang="less" scoped>
.home-flow {
	display: flex;
	flex-direction: column;
	min-height: 100vh;
	overflow: hidden;
}
</style>
